<template>
  <el-dialog
  :visible="dialogVisible"
  :fullscreen="true"
  :close-on-press-escape="false"
  :show-close="false"
  append-to-body
  center
  v-loading.fullscreen.lock="fullScreenLoading"
  @open="open">
  <span slot="title" class="dialog-header">
    <span v-if="!isEditionMode()" class="title" >{{ $t('purchase_orders.newPurchaseOrder') }}</span>
    <span v-if="isEditionMode()" class="title" >{{ $t('purchase_orders.editPurchaseOrder') }}</span>
  </span>
  <el-row justify="center">
    <el-col class="formContainer" :xs="24" :sm="24" :md="20" :lg="20" :xl="20">
      <el-form label-position="top" label-width="100px" :model="purchaseOrder" :rules="rules" ref="poForm">
        <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item :label="$t('purchase_orders.purchaseOrderNumber')">
              <el-input v-model="purchaseOrder.po_number" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item :label="$t('purchase_orders.accountable')" prop="accountant">
              <el-select v-model="accountant" placeholder="Select" value-key="id">
                <el-option
                  v-for="user in users"
                  :key="user.id"
                  :label="getUserName(user)"
                  :value="user">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item :label="$t('purchase_orders.provider')" prop="vendor">
              <el-select
                v-model="vendor"
                filterable
                remote
                reserve-keyword
                clearable
                :label="$t('purchase_orders.provider')"
                :remote-method="fetchSearchedVendors"
                :loading="loadingVendors"
                :loading-text="$i18n.t('loading')"
                value-key="id">
                <el-option
                  v-for="item in vendors"
                  :key="item.id"
                  :label="item.usual_name+'('+item.name+')'"
                  :value="item">
                  <i v-if="item.company==null" class="mdi mdi-account-circle align-vertical-middle"></i>
                  <i v-else class="mdi mdi-city align-vertical-middle"></i>
                  <span style="margin-left:5px; color: #8492a6; font-size: 13px" v-if="(item.usual_name==null || item.usual_name=='') || (item.usual_name==item.name)">{{ item.name }}</span>
                  <span style="margin-left:5px; color: #8492a6; font-size: 13px" v-else>{{ item.usual_name }}({{item.name}})</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item :label="$t('purchase_orders.Reference')">
              <el-input v-model="reference"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item :label="$t('purchase_orders.Reference2')">
              <el-input v-model="reference2"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-divider><i class="el-icon-truck"></i></el-divider>
        <el-form-item label="Livré à" >
          <el-radio v-model="deliverToChoice" label="1" border :disabled="true">Organization</el-radio>
          <el-radio v-model="deliverToChoice" label="2" border :disabled="true">Clients</el-radio>
        </el-form-item> -->
        <el-divider><i class="el-icon-more-outline"></i></el-divider>
        <el-row>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item :label="$t('common.date')" prop="date">
              <el-date-picker v-model="date" type="date"  @change="setDate"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
            <el-form-item :label="$t('purchase_orders.deliveryTime')">
               <el-input-number v-model="shippingDelay" :disabled="purchaseOrder.date==null" :min="0" :step="7"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
            <el-form-item :label="$t('purchase_orders.expectedDeliveryDate')">
              <el-date-picker v-model="receptionPlanningDate" type="date" :picker-options="datePickerPlanningOptions"  ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <h3>{{ $t('purchase_orders.detailTitle') }}</h3>
        <el-row :gutter="20" class="sticky" ref="sticky-element">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item :label="$t('purchase_orders.selectProduct')">
                <el-autocomplete class="inline-input"  v-model="selectedProduct" style="width:100%;" :fetch-suggestions="querySearch" @select="selectItem">
                  <template slot-scope="{ item }">
                      <itemTemplate :showQty="false" :showInventoryName="false" :product="item" :inventory="item.inventory"></itemTemplate>
                  </template>
                </el-autocomplete>
              </el-form-item>
          </el-col>
        </el-row>
        <ElTableDraggable @drop="handleDrop" :animate="300" handle=".handle">
          <el-table
            :data="purchaseOrder.lines"
            style="width: 100%"
            header-row-class-name="sticky"
            >
            <span slot="empty">Aucun produit ajouté</span>
            <el-table-column width="30">
              <template slot-scope="scope">
                <div class="handle">
                  <i class="mdi mdi-drag handle"/>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :label="productLabel">
              <template slot-scope="scope">
                <div>
                  <span>{{scope.row.product.name}}</span><br>
                  <span class="fs-14 secondary-text">SKU : {{scope.row.product.sku}}</span><br>
                  <UnitFormatVolumeLabel
                    :unit="scope.row.product.unit"
                    :volume="scope.row.product.volume"
                    :format="scope.row.product.format"
                    :uvc="scope.row.product.uvc"
                  />
                </div>
                <div>
                  <div v-if="!mergeItemInventory" class="mb-5">
                    <el-checkbox :value="scope.row.distinct" @change="v => handleDistincProduct(v, scope.$index)">Produit distinct</el-checkbox>
                    <br>
                      <products-inventory-options
                        :productsInventory="scope.row.productsInventory"
                        :distinct="scope.row.distinct"
                        :puid="scope.row.puid"
                        @change="v => setProductPuid(scope.$index, v)"
                        :genericPuid="scope.row.generic_puid"/>
                    <br>
                  </div>
                  <el-input :placeholder="$t('purchase_orders.lines.Reference')" :value="scope.row.reference" @input="v => setReference(scope.$index, v)"></el-input><br>
                  <el-input type="textarea" :value="scope.row.purchase_description" :autosize="{ minRows: 2, maxRows: 3}" :placeholder="$t('common.addDescription')" style="margin-top:5px;" @input="v => setPurchaseDescription(scope.$index, v)"></el-input><br>
                  
                  <TechnicalSheetSelect
                    class="pt-5"
                    :disabled="isCompletelyReceived"
                    :productItem="scope.row.productItem"
                    :product="scope.row.product"
                    @change="v => handleTechnicalSheetChange(v, scope.$index)"
                  />
                  <br>
                  <el-popover placement="top" width="300" trigger="click" v-if="purchaseOrderLinesCustomFieldsDefinition.length>0">
                    <p>{{ $t('purchase_orders.suppInfo') }}</p>
                    <div style="margin: 0">
                      <el-form>
                        <div v-for="(customFieldDef, customFieldIndex) in purchaseOrderLinesCustomFieldsDefinition" :key="customFieldDef.id">
                          <el-form-item :label="$t('purchase_orders.lines.customFields.'+customFieldDef.value.code)">
                            <el-input v-if="customFieldDef.value.type=='number'" :value="scope.row.custom_fields[customFieldIndex].value" @input="v => setCustomFieldValue(scope.$index,customFieldIndex,v,customFieldDef.value.code)"></el-input>
                            <el-select v-if="customFieldDef.value.type=='list'" placeholder="Selectionner" :value="scope.row.custom_fields[customFieldIndex].value" @input="v => setCustomFieldValue(scope.$index,customFieldIndex,v,customFieldDef.value.code)">
                              <el-option v-for="(item, index) in customFieldDef.value.values[$i18n.locale] "
                                :key="index"
                                :label="item"
                                :value="index">
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                      </el-form>
                    </div>
                    <el-button slot="reference" type="text"><i class="el-icon-set-up"></i><span class="fs-14">{{ $t('purchase_orders.suppInfo') }}</span></el-button>
                  </el-popover>
                  <el-popover placement="top" width="300" trigger="click" v-if="purchaseOrderLinesCustomFieldsDefinition.length >0 && inventory.ind_agency === true">
                    <p>{{ $t('purchase_orders.salesPrice') }}</p>
                    <div style="margin: 0">
                      <el-form>
                        <el-form-item :label="$t('purchase_orders.priceWithLicence')">
                          <el-input-number  :value="scope.row.price" :disabled="true" :controls="false"></el-input-number>
                        </el-form-item>
                        <el-form-item :label="$t('purchase_orders.priceWithoutLicence')">
                          <el-input-number  :value="scope.row.price_tax_in" @input="v => setPriceTaxIn(scope.$index,v)" :controls="false"></el-input-number>
                        </el-form-item>
                      </el-form>
                    </div>
                    <el-button slot="reference" type="text" :disabled="isCompletelyReceived"><i class="el-icon-money" style="margin-left:10px;"></i><span class="fs-14">{{$t('purchase_orders.price')}}</span></el-button>
                  </el-popover>
                 
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :label="quantityLabel"
              width="280"
              align="center"
              >
              <template slot-scope="scope">
                <unitQuantities @change="v => setQtyOrdered(scope.$index, v)" :default="scope.row.qty_ordered"  :product_unit="scope.row.product.unit" :product_uvc="scope.row.product.uvc" :default_unit="scope.row.product.unit" ></unitQuantities>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('purchase_orders.costPrice')"
              width="150">
              <template slot-scope="scope">
                  <el-input-number placeholder="1" :value="scope.row.purchase_unit_price" :controls="false" style="width:120px" @input="v => setPurchaseUnitPrice(scope.$index, v)"></el-input-number>
                  <div v-if="marginEnabled">
                    <el-row>
                      <el-col>
                        <MarginRatePopover :margin_rate="scope.row.margin_rate" :margin_type="scope.row.margin_type" @applyMargin="v=>setLineMargin(v,scope.$index)"></MarginRatePopover>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col>
                        <span>{{ $t('purchase_orders.marginField') }} <span>{{$n(scope.row.margin,'currency',vendorCurrency)}}</span></span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col>
                        <span>{{ $t('purchase_orders.totalField') }} <span>{{$n(scope.row.margin_price,'currency',vendorCurrency)}}</span></span>
                      </el-col>
                    </el-row>
                  </div>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('purchase_orders.subTotal')"
              width="150"
              align="center">
              <template slot-scope="scope">
                <span>{{$n(scope.row.total,'currency',vendorCurrency)}}</span>
              </template>
            </el-table-column>
            <el-table-column
              width="50">
              <template slot-scope="scope">
                <el-link style="color:red;" icon="el-icon-close" :underline="false" @click="removeLine(scope.$index)"></el-link>
              </template>
            </el-table-column>
          </el-table>
        </ElTableDraggable>
        <div style="height:275px;display:block;">
          <div style="height:275px;margin-top:40px;float:right;">
            <div style="position:relative;width:400px;margin:20px;border-bottom:1px solid #EBEEF5;height:30px;padding-bottom:20px">
              <div style="margin-left:20px;float:left;font-weight:bold;color:#909399">{{ $t('purchase_orders.subTotalField') }}</div>
              <div style="float:right;color:#909399">{{$n(subTotal, 'currency',vendorCurrency)}}</div>
            </div>
            <div style="position:relative;width:400px;margin:20px;border-bottom:1px solid #EBEEF5;height:30px;padding-bottom:20px">
              <div style="margin-left:20px;float:left;font-weight:bold;color:#909399;">{{ $t('purchase_orders.adjustmentField') }} </div>
              <div style="float:right;color:#909399"><el-input-number v-model="adjustment" size="mini" :controls="false"></el-input-number></div>
            </div>
            <div style="position:relative;width:400px;margin:20px;border-bottom:1px solid #EBEEF5;height:30px;padding-bottom:20px">
              <div style="margin-left:20px;float:left;font-weight:bold;color:#909399">{{ $t('purchase_orders.totalField') }} </div>
              <div style="float:right;color:#909399">{{$n(total,'currency',vendorCurrency)}}</div>
            </div>
          </div>
        </div>
      <el-divider style="margin-top:200px;"></el-divider>
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-form-item label="Notes">
            <el-input type="textarea" :rows="5" resize="none" v-model="notes"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-form-item :label="$t('purchase_orders.termsAndConditions')">
            <el-input type="textarea" :rows="5" resize="none" v-model="terms_conditions"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      </el-form>
    </el-col>
  </el-row>

  <span slot="footer" class="dialog-footer card-shadow--large">
    <el-button @click="closePODialog">{{$t('common.Cancel')}}</el-button>
    <el-button v-if="!isEditionMode()" type="primary" @click="addPO" :disabled="fullScreenLoading">{{ $t('common.save') }}</el-button>
    <el-button v-if="isEditionMode()" type="primary" @click="editPO" :disabled="fullScreenLoading">{{ $t('common.Edit') }}</el-button>
  </span>
</el-dialog>
</template>
<script>
import itemTemplate from '@/components/product/item-template'
import UsersAPI from '@/services/API/user'
import unitQuantities from '@/components/product/unit-quantities';
import MarginRatePopover from '@/components/margin-rate-popover'
import { mapActions, mapState, mapGetters } from 'vuex';
import ElTableDraggable from '@/components/SortableElTable';
import PurchaseReceiveAPI from '@/services/API/purchase-receive'
import inventoryAPI from '@/services/API/inventory'
import UnitFormatVolumeLabel from '@/components/product/unitFormatVolumeLabel'
import TechnicalSheetSelect from '@/components/technical-sheet-select'
import ProductsInventoryOptions from './products-inventory-options'
export default {
  name: 'PurchaseOrderDialog',
	props: {
		dialogVisible : Boolean,
    editSelectedPurchaseOrder : {
      type : Boolean,
      default : false
    },
    inventoryId : String,

	},
  data() {
    return {
      purchaseReceives : [],
      searchTimeOut: null,
      selectedProduct : null,
      po : {},
      datePickerPlanningOptions: {
          disabledDate :this.disabledPlanningDateBeforeDate
        },
      rules : {
        vendor : [
  	  		 	{ required: true, message: 'Veuillez saisir un fournisseur.', trigger: 'blur' }
  	  		],
  	  	date : [
  	  		 	{ required: true, message: 'Veuillez saisir une date', trigger: 'blur' }
  	  		],
        accountant : [
          	{ required: true, message: 'Veuillez sélectionner la personne responsable', trigger: 'blur' }
        ]
  	  },
      fullScreenLoading : false,
      deliverToChoice : '1',
      users : [],
    };
  },components: {
    itemTemplate,
    unitQuantities,
    MarginRatePopover,
    ElTableDraggable,
    UnitFormatVolumeLabel,
    TechnicalSheetSelect,
    ProductsInventoryOptions,
  },
	methods: {
    filterProductInventories (productInventories, puid) {
      return _.filter(productInventories, p=> p.puid !== puid);
    },
    handleTechnicalSheetChange (productItem, index) {
      this.setLineProp({index, lineProp:{ productItem }});
    },
    handleDrop(newOrdering){
      this.setOrdering_(newOrdering)
    },
    setLineMargin({type, rate}, index){
      this.setMargin({type, rate, index});
    },
    handleDistincProduct(distinct, index){
      this.setDistinctProduct({distinct, index});
    },
    ceil(qty){
      return Math.ceil(qty);
    },
    querySearch(queryString, cb){
      if (_.trim(queryString) === '') {
        cb([]);
      } else {
        clearTimeout(this.searchTimeOut);
        this.searchTimeOut = setTimeout(() => {
          this.fetchSearchedProducts(queryString)
          .then(()=>{
             cb(this.products);
          })
        }, 500)

      }
    },
    setPrice(index,v){
      this.setPurchaseOrderPrice({index, price:v});
    },
    setPriceTaxIn(index,v){
      this.setPurchaseOrderPriceTaxIn({index, price:v});
    },
    setCustomFieldValue(index, customFieldIndex, customFieldValue,customFieldCode){
      this.setPurchaseOrderLineCustomField({index, customFieldIndex, customFieldValue, customFieldCode});
    },
    setPurchaseDescription(index, purchase_description){
      this.setLineProp({index, lineProp:{purchase_description}});
    },
    setReference(index, reference){
      this.setLineProp({index, lineProp:{reference}});
    },
    setQtyOrdered(index, qty_ordered){

      this.setLineProp({index, lineProp:{qty_ordered}});
    },
    setQtyOrderedUVC(index, qty_ordered_uvc){
      this.setLineProp({index, lineProp:{qty_ordered_uvc}});
    },
    setPurchaseUnitPrice(index, purchase_unit_price){
      this.setLineProp({index, lineProp:{purchase_unit_price}});
    },
    setProductPuid(index, puid) {
      if (puid === '' || puid == null) {
        this.generatePuidForPurchaseOrderLine(index);
      }
      this.setLineProp({index, lineProp:{puid}});
    },
    setDate(date){
      this.setPurchaseOrderProp({date})
    },
    disabledPlanningDateBeforeDate (date) {
        return  date < this.po.date;
    },
    shouldCreateNewItems(){
      let line = _.find(this.po.items, line=>{return line.id==null;})
      return line==null;
    },
    selectItem(product){
      this.addLine(product)
        .then(productAdded=>{
          if(!productAdded){
            this.$notify({
                title: 'Attention',
                message: 'Ce produit est déjà ajouté au bon de commande',
                type: 'warning'
              });
          }
        })
    },
    isEditionMode(){
      return this.editSelectedPurchaseOrder==true;
    },
    fetchPurchaseReceives(purchaseOrderId){
      if (purchaseOrderId != null) {
        return PurchaseReceiveAPI.list(purchaseOrderId)
          .then(purchaseReceives=>{
            this.purchaseReceives=purchaseReceives;
          })
      }
    },
    open(){
      this.initPurchaseOrderEditor(this.inventoryId);
      if(this.purchaseOrder.vendor != null){
        this.fetchVendor(this.purchaseOrder.vendor.id);
      }
      this.fetchPurchaseReceives(this.purchaseOrder.id);
      this.fetchPurchaseOrderStatuses();
      this.listUsers()
    },
    closePODialog(){
       this.reset();
       this.$refs['poForm'].resetFields();
       this.$emit('close');
    },
    validateitems(){
      //Il doit y  avoir au moins une ligne et cette ligne doit avoir un item validate
      // let valid = false;
      // _.forEach(this.po.items, line=>{
      //     if(!valid){
      //       valid = line.item_header!=null?true:false;
      //     }
      // })
      // return valid;

      //Ajouter les règles d'affaires ici
      return true;
    },
    addPO(){

      var itemsValid = this.validateitems()
      this.$refs['poForm'].validate((valid)=>{
        if(valid && itemsValid){
          this.fullScreenLoading=true;
          this.postPurchaseOrder('save')
            .then(purchaseOrderCreatedId=>{
              this.fullScreenLoading=false;
              this.closePODialog();
              this.invalidateStockItems();
              var index = '/inventories/' + this.inventoryId+'/purchase-orders/'+purchaseOrderCreatedId;
              this.$router.push(index)
              this.$emit('push-page', {page:index})
              //invalidate stockItems listItems

            }).catch(err=>{
                this.fullScreenLoading=false;
                this.$notify({
                    title: 'Erreur',
                    message: 'Une erreur système est survenue. Veuillez réessayer plus tard.',
                    type: 'error'
                  });
              })
        }else{
          if(valid && !itemsValid){
            this.$notify({
                title: 'Avertissement',
                message: 'Vous devez ajouter au moins une ligne de produit valide dans le bon de commande',
                type: 'warning'
              });
          }else{
            this.$notify({
                title: 'Avertissement',
                message: "Certains champs obligatoires n'ont pas été renseignés.",
                type: 'warning'
              });
          }
        }
      })

    },
    editPO(){
      var itemsValid = this.validateitems()

      this.$refs['poForm'].validate((valid)=>{
        if(valid && itemsValid){
          this.fullScreenLoading=true;
          this.putPurchaseOrder('save')
            .then(()=>{
              this.fullScreenLoading=false;
              this.closePODialog();
              this.$notify({
                  title: 'Succès',
                  message: 'Votre bon de commande a été sauvegardé avec succès',
                  type: 'success'
                });
            }).catch(err=>{
              this.fullScreenLoading=false;
              this.$notify({
                  title: 'Erreur',
                  message: 'Une erreur système est survenue. Veuillez réessayer plus tard.',
                  type: 'error'
                });
            })
        }else{
          if(valid && !itemsValid){
            this.$notify({
                title: 'Avertissement',
                message: 'Vous devez ajouter au moins une ligne de produit valide dans le bon de commande',
                type: 'warning'
              });
          }else{
            this.$notify({
                title: 'Avertissement',
                message: "Certains champs obligatoires n'ont pas été renseignés.",
                type: 'warning'
              });
          }
        }
      })
    },
    getUserName(user){
      return user.first_name + " " + user.last_name;
    },
    listUsers(){
      return UsersAPI.listAdminUser()
        .then(users=>{
          this.users = users;
          return this.users;
        })
    },
    ...mapActions('stockItems',['invalidateStockItems']),
    ...mapActions('statuses',['fetchPurchaseOrderStatuses']),
    ...mapActions('purchaseOrderEditor', ['initPurchaseOrderEditor','fetchSearchedProducts','fetchSearchedVendors','fetchVendor','setPurchaseOrderProp','addLine','setLineProp','removeLine','reset','postPurchaseOrder','putPurchaseOrder','setShippingDelay','setPurchaseOrderLineCustomField','setPurchaseOrderPriceTaxIn','setPurchaseOrderPrice','setMargin','setOrdering_', 'generatePuidForPurchaseOrderLine', 'setDistinctProduct'])
	},
	computed: {
    mergeItemInventory () {
      return _.get(this.inventory, 'ind_item_merged') === true;
    },
    productLabel () {
      return `${this.$i18n.t('purchase_orders.product')} (${this.nbLines})`;
    },
    quantityLabel () {
      return `${this.$i18n.t('purchase_orders.quantity')} (${this.totalQuantities})`;
    },
    nbLines () {
      return this.purchaseOrder.lines.length;
    },
    totalQuantities (){
      let count = 0;
      _.forEach(this.purchaseOrder.lines, (l) => {
        count += l.qty_ordered;
      })
      return count;
    },
    isCompletelyReceived(){
      let isCompletelyReceived= false;
      if(this.purchaseOrder.status!=null && this.purchaseOrder.status.code=="RECEIVED"){
        isCompletelyReceived = true;
      }
      return isCompletelyReceived
    },
    marginEnabled(){
      return localStorage.PURCHASE_ORDER_MARGIN=='1';
    },
    calculateQuantityUVC(){
      return localStorage.CALCULATE_QUANTITY_UVC!=null&&localStorage.CALCULATE_QUANTITY_UVC==='1';
    },
    reference : {
      set(reference){this.setPurchaseOrderProp({reference})},
      get(){return this.purchaseOrder.reference}
    },
    reference2 : {
      set(reference2){this.setPurchaseOrderProp({reference2})},
      get(){return this.purchaseOrder.reference2}
    },
    shippingDelay : {
      set(shippingDelay){this.setShippingDelay(shippingDelay)},
      get(){return this.purchaseOrder.shipping_delay}
    },
    adjustment : {
      set(adjustment){this.setPurchaseOrderProp({adjustment})},
      get(){return this.purchaseOrder.adjustment}
    },
    notes : {
      set(notes){this.setPurchaseOrderProp({notes})},
      get(){return this.purchaseOrder.notes}
    },
    terms_conditions : {
      set(terms_conditions){this.setPurchaseOrderProp({terms_conditions})},
      get(){return this.purchaseOrder.terms_conditions}
    },
    accountant : {
      set(accountant){this.setPurchaseOrderProp({accountant})},
      get(){return this.purchaseOrder.accountant}
    },
    vendor : {
      set(vendor){this.setPurchaseOrderProp({vendor})},
      get(){return this.purchaseOrder.vendor}
    },
    date : {
      set(date){this.setPurchaseOrderProp({date})},
      get(){return this.purchaseOrder.date}
    },
    receptionPlanningDate : {
      set(reception_planning_date){this.setPurchaseOrderProp({reception_planning_date})},
      get(){return this.purchaseOrder.reception_planning_date}
    },
    ...mapState('purchaseOrderEditor', ['purchaseOrder','products','loadingProducts','vendors','loadingVendors']),
    ...mapState('inventoryProducts', ['inventory']),
    ...mapGetters('purchaseOrderEditor',['marginFormatted','totalWithMargin','unitFormatted', 'subTotal','total','vendorCurrency']),
    ...mapState('controlData',['purchaseOrderLinesCustomFieldsDefinition'])
	}
}
</script>
<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';

.sticky {
  position: -webkit-sticky;
  position: sticky;
  top:0px;
  padding-top:20px;
  z-index:1000;background-color:#ffffff;
}

.shadow {
  position: sticky;
  width: 100%;
  box-shadow: 0 2px 1px 1px rgba(0, 0, 0, 0.3);
}

.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-20px;
  padding-top:10px;
  border-top:1px solid #E4E7ED;
  z-index:100;
}

.el-input__inner{
  border:0px;
}
.title {
	font-size : 1.6em;
	font-weight:bold;

}

  .flip-list-move {
    transition: transform 0.5s;
  }

  .no-move {
    transition: transform 0s;
  }

  .ghost {
    opacity: 0.5;
    background: #c8ebfb;
  }

  .handle {
      cursor: move; /* fallback if grab cursor is unsupported */
      cursor: grab;
      cursor: -moz-grab;
      cursor: -webkit-grab;
  }

  /* (Optional) Apply a "closed-hand" cursor during drag operation. */
  .handle:active {
      cursor: grabbing;
      cursor: -moz-grabbing;
      cursor: -webkit-grabbing;
  }

  .formContainer{
      margin-left:10%;
      width:80%;
    }

@media (max-width: 1366px) {
  .formContainer{
      margin-left:5%;
      width:90%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}

</style>
